export default __webpack_public_path__ + "static/media/4metri.3556d858.png";